import { ArrayUtils } from "source/app/services/ArrayUtils";
import Music from "source/app/services/Sound/Music/Music";
import { Sounds } from "source/app/services/Sound/Sounds";
import Background from "source/app/services/UI/Background/Background";
import { AttachKeyboardEvents } from "source/app/services/UI/KeyboardEvents/Global/AttachKeyboardEvents";
import { GetCachedRadioStationsAsync } from "../../services/Sound/Radio/CachedRadioStations";
import { desktopKeyboardEvents } from "./../../services/UI/KeyboardEvents/DesktopKeyboardEvents";
import IDevice from "./IDevice";
import Ambience from "source/app/services/Sound/Ambience/Ambience";

export default class DesktopDevice implements IDevice {
    Initialize(): void {
        Ambience.StartNextAmbience();
        Background.ChangeImage();
        this.PlayRandomIntroSoundAndStartMusic();
        AttachKeyboardEvents(desktopKeyboardEvents);
        GetCachedRadioStationsAsync();
    }

    PlayRandomIntroSoundAndStartMusic = () => {
        const randomSound = ArrayUtils.GetRandomElement([
            Sounds.trumpetFanfare,
            Sounds.brothersChant,
        ]);

        Music.Duck();
        Music.StartNextSong();

        randomSound.Play({
            onEnd: () => {
                Music.UnDuck();
            },
        });
    };
}
